import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Box } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from "flowbite-react";
import slide2Image from "../assets/2.png";
import "./Banner.css";
import apiClient from "../components/apiClient";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";

const Banner = () => {
  const [mediaFiles, setMediaFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const videoRefs = useRef([]);

  // (Optional) reference if you want to control video more
  const videoRef = useRef(null);

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
    }
  };

  // useEffect(() => {
  //   const fetchBanners = async () => {
  //     try {
  //       const response = await apiClient.get("/banner");
  //       console.log("API Response:", response.data); // Debugging purpose

  //       if (response.data?.banners?.length > 0) {
  //         // Flatten all media (images & videos) from different banners into one array
  //         const allMedia = response.data.banners.flatMap(
  //           (banner) => banner.image || [],
  //         );
  //         setMediaFiles(allMedia);
  //       } else {
  //         setError("No banners found.");
  //       }
  //     } catch (err) {
  //       console.error(err);
  //       setError("Failed to fetch banners.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBanners();
  // }, []);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await apiClient.get("/banner");
        // const response = await axios.get("http://192.168.1.64:2000/banner");

        if (response.data?.banners?.length > 0) {
          const allMedia = response.data.banners.flatMap((banner) =>
            banner.image.map((img) => ({
              url: img,
              link: banner.url_link,
            }))
          );
          setMediaFiles(allMedia);
        } else {
          setError("No banners found.");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch banners.");
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // useEffect(() => {
  //   if (mediaFiles.length === 0) return; // Prevents useEffect from running when there's no media

  //   const isVideo = mediaFiles[currentIndex]?.endsWith(".mp4");
  //   const intervalTime = isVideo ? 10000 : 5000; // 10s for video, 5s for image

  //   const interval = setTimeout(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaFiles.length);
  //   }, intervalTime);

  //   return () => clearTimeout(interval);
  // }, [currentIndex, mediaFiles]);

  useEffect(() => {
    if (mediaFiles.length === 0) return;

    const isVideo = mediaFiles[currentIndex]?.url?.endsWith(".mp4");
    const intervalTime = isVideo ? 10000 : 5000;

    const interval = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaFiles.length);
    }, intervalTime);

    return () => clearTimeout(interval);
  }, [currentIndex, mediaFiles]);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentIndex) {
          video.muted = isMuted;
          video.play().catch((err) => console.error("Play error", err));
        } else {
          video.pause();
          video.currentTime = 0; // 🔥 optional: reset to beginning
        }
      }
    });
  }, [currentIndex, isMuted, mediaFiles]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const prevSlide = () =>
    setCurrentIndex((prev) => (prev === 0 ? mediaFiles.length - 1 : prev - 1));
  const nextSlide = () =>
    setCurrentIndex((prev) => (prev + 1) % mediaFiles.length);

  const mediaFiless = [
    "https://youtu.be/blJJDgSG4cI", // YouTube
    "https://assets.pinterest.com/ext/embed.html?id=706361522841435749", // Pinterest
    "/images/sample1.jpg", // Image from DB
  ];

  // Helper to extract YouTube video ID
  const getYoutubeId = (url) => {
    const short = url.match(/youtu\.be\/([^\?&]+)/);
    const long = url.match(/v=([^\?&]+)/);
    return short ? short[1] : long ? long[1] : null;
  };

  const isYouTube = (url) => url.includes("youtu");
  const isPinterest = (url) => url.includes("pinterest");

  // return (
  //   <div className="relative w-full h-0 pb-[40%]">
  //     <Carousel slideInterval={5000} className="absolute top-0 left-0 w-full h-full">
  //       {mediaFiles.length > 0 ? (
  //         mediaFiles.map((file, index) => {
  //           const isVideo = file.endsWith(".mp4");

  //           return (
  //             <div key={index} className="w-full h-full flex items-center justify-center">
  //               {isVideo ? (
  //                 <video
  //                   src={file}
  //                   className="w-full h-full object-cover"
  //                   autoPlay
  //                   muted
  //                   loop
  //                   playsInline
  //                   controls
  //                 />
  //               ) : (
  //                 <img
  //                   src={file}
  //                   alt={`Slide ${index + 1}`}
  //                   className="w-full h-full object-cover"
  //                 />
  //               )}
  //             </div>
  //           );
  //         })
  //       ) : (
  //         <p>No media available</p>
  //       )}
  //     </Carousel>
  //   </div>
  // );

  return (
    <div className="relative w-full h-[300px] md:h-[700px] lg:h-[800px] overflow-hidden">
      {/* <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
        {mediaFiles.length > 0 ? (
          mediaFiles.map((file, index) => (
            <div
              key={index}
              className={`absolute top-0 left-0 w-full h-full flex items-center justify-center transition-opacity duration-700 ${
                index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              {file.endsWith(".mp4") ? (
                <video
                  src={file}
                  className="w-full h-full object-cover pointer-events-none"
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                />
              ) : (
                <img src={file} alt={`Slide ${index + 1}`} className="w-full h-full object-cover" />
              )}
             
            </div>
          ))
        ) : (
          <p>No media available</p>
        )}
      </div> */}
      {mediaFiles.map((file, index) => {
        const isVideo = file.url.endsWith(".mp4");
        const isActive = index === currentIndex;
        return (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center transition-opacity duration-700 ${
              isActive ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          >
            <a
              href={file.link}
              rel="noopener noreferrer"
              className="w-full h-full relative"
            >
              {isVideo ? (
                <div className="w-full h-full relative">
                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    src={file.url}
                    className="w-full h-full object-cover pointer-events-none"
                    autoPlay
                    loop
                    playsInline
                    muted={isMuted}
                  />
                  {/* {isActive && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMute();
                      }}
                      className="absolute bottom-4 right-4 bg-black bg-opacity-50 p-2 rounded-full text-white"
                    >
                      {isMuted ? (
                        <FaVolumeMute className="text-2xl" />
                      ) : (
                        <FaVolumeUp className="text-2xl" />
                      )}
                    </button>
                  )} */}
                  {isActive && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMute();
                      }}
                      className="absolute bottom-4 right-4 bg-black bg-opacity-50 p-2 rounded-full text-white no-hover-zoom"
                    >
                      {isMuted ? (
                        <FaVolumeMute className="text-2xl" />
                      ) : (
                        <FaVolumeUp className="text-2xl" />
                      )}
                    </button>
                  )}
                </div>
              ) : (
                <img
                  src={file.url}
                  alt={`Banner ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              )}
            </a>
          </div>
        );
      })}

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-20 hover:bg-black/70"
      >
        <ChevronLeft size={32} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-20 hover:bg-black/70"
      >
        <ChevronRight size={32} />
      </button>

      {/* Slide Indicators (Dots) */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {mediaFiles.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`w-3 h-3 rounded-full ${
              idx === currentIndex ? "bg-white" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Banner;
